<template>
  <div class="pc-list" ref="list">
    <EntrySearch @search="search" />
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteEntryInit">删除</button>
          <span></span>
          <button @click="addEntry">添加</button>
          <span></span>
          <button @click="exportentry">导出数据</button>
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table class="pc-list-table" @sort-change="changeSort" :data="entryList">
      <el-table-column width="100" class="singleCheckStyle" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope" fixed="left">
          <el-checkbox
            v-model="entryList[scope.$index].isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="image" label="图片" width="100" fixed="left">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img v-if="scope.row.image" :src="scope.row.image" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="chinese_name"
        label="名称"
        sortable="custom"
        width="150"
      >
        <template slot-scope="scope">
          <div>
            {{
              scope.row.chinese_name
                ? scope.row.chinese_name
                : scope.row.english_name
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="entryList.author_chinese_name"
        label="作者"
        width="190"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.author_chinese_name">
            {{
              scope.row.author_chinese_name
                ? scope.row.author_chinese_name
                : scope.row.author_english_name | scholarname
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标签" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.classification">
            {{ scope.row.classification.chinese_name }} <br />
            {{ scope.row.classification.english_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" sortable="custom" width="130">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            @change="changeState(scope.row)"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="update_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.update_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column width="180">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="entryList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
  </div>
</template>

<script>
import Pagination from "@/components/componentSet/Pagination";
import EntrySearch from "./EntrySearch";
import DeleteHint from "@/components/template/DeleteHint";
import {
  entryList_Api,
  updateEntryDetail_Api,
  deleteEntryList_Api,
  outputEntry_Api,
} from "@/apis/entry.api";
export default {
  components: {
    EntrySearch,
    Pagination,
    DeleteHint,
  },
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      isSelectAll: false,
      entryList: [],
      checked: [],
    };
  },
  filters: {
    scholarname: function (value) {
      for (let i in value) {
        return value.toString();
      }
    },
  },
  mounted() {
    this.getEntryListByRules(this.searchRules);
  },
  methods: {
    // 获取
    getEntryListByRules(data) {
      this.loading = true;
      entryList_Api(data)
        .then((res) => {
          console.log(res);
          this.$set(this.pagination_options, "total", res.count);
          res.data.forEach((el) => {
            el.isSelect = false;
          });
          this.entryList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.entryList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.entryList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getEntryListByRules(data);
      this.pagination_options.page = 1;
    },
    viewDetail(item) {
      let route = this.$router.resolve({
        path: "/admin/entrydetail",
        query: { id: item.id, method: "update" },
        name: "entrydetail",
        params: item,
      });
      window.open(route.href, "_blank");
    },

    // 修改状态
    changeState(row) {
      updateEntryDetail_Api({ entry_id: row.id, status: row.status })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getEntryListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.entry_id) {
        data.entry_id = parseInt(formData.entry_id);
      }
      if (formData.isSelect) {
        data.isSelect = formData.isSelect;
      }
      if (formData.status) {
        data.status = parseInt(formData.status);
      }
      if (formData.name_keywords && formData.name_keywords.length > 0) {
        data.name_keywords = [...formData.name_keywords];
      }
      if (formData.author_keywords && formData.author_keywords.length > 0) {
        data.author_keywords = [...formData.author_keywords];
      }

      if (formData.classification_id) {
        data.classification_id = parseInt(formData.classification_id);
      }
      return data;
    },
    isDelete() {
      let delete_ids = { entry_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteEntryList_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          let data = this.dealSearchRules(this.searchRules);
          this.getEntryListByRules(data);
          this.pagination_options.page = 1;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    deleteEntryInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的词条！", null);
      }
    },
    addEntry() {
      let route = this.$router.resolve({
        path: "/admin/entrydetail",
        query: { method: "add" },
      });
      window.open(route.href, "_blank");
    },
    // 到出数据
    exportentry() {
      if (this.checked.length > 0) {
        outputEntry_Api({ entry_id_list: this.checked }).then((res) => {
          this.$global.downloadFile(res, "entryList");
        });
      } else {
        this.$global.error(this, "请先勾选要导出的项目！", null);
      }
    },

    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getEntryListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-list {
  @include table-head;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/entry/components/EntryTable.vue